import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useMediaQuery, makeStyles, useTheme } from '@material-ui/core';

import { Sidebar, Topbar, Footer } from './components';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 56,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64
    }
  },
  shiftContent: {
    paddingLeft: 240
  },
  content: {
    height: '100%'
  }
}));

const DesktopSideMenuLayout = (props) => {
  const { children } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });

  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    console.log(
      '00-4432-101 DesktopSideMenuLayout - Sidebar - handleSidebarClose '
    );
    setOpenSidebar(false);
  };

  const shouldOpenSidebar = isDesktop ? true : openSidebar;

  // console.log('4432-722 DesktopSideMenuLayout - props = ', props);
  // console.log('4432-723 DesktopSideMenuLayout - props.currentUser = ', props.children.props.currentUser);

  return (
    <div
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: isDesktop
      })}>
      <Topbar onSidebarOpen={handleSidebarOpen} />
      <Sidebar
        onClose={handleSidebarClose}
        open={shouldOpenSidebar}
        variant={isDesktop ? 'persistent' : 'temporary'}
        currentuser={props.children.props.currentUser}
      />
      <main className={classes.content}>
        {children}
        <Footer />
      </main>
    </div>
  );
};

DesktopSideMenuLayout.propTypes = {
  children: PropTypes.node
};

export default DesktopSideMenuLayout;
